<template>
  <div class="section__response">
    <table class="responses__table">
      <!-- header start) code, description, links 부분  -->
      <thead>
      <tr class="responses__header">
        <td class="col__header res__code">Code</td>
        <td class="col__header res__description">Description</td>
        <td class="col__header res__link">Links</td>
      </tr>
      </thead>
      <!-- header end) -->

      <!-- body start) body 부분(하나의 컴포넌트라고 생각하고 for문 돌려서 데이터가 갖고 있는 key 만큼 뿌려줌(for 문 이용) -->
      <tbody v-for="key in Object.keys(data.responses)">
      <!-- tr start) key 행 -->
      <tr class="responses">
        <!-- td key start) key 값 뿌려주는 열 (200 || default) -->
        <td class="res__key">
          {{ key }}
        </td>
        <!-- td key end) -->

        <!-- td des start) description 요소 뿌려주는 열 -->
        <td class="res__description">
          <!-- des div start) description 한 줄 뿌려줌 -->
          <div class="res__description__inner">
            <p v-html="converted(data.responses[key].description)"></p>
          </div>
          <!-- des div end) -->

          <!-- section start) des 요소 중 control 부분 -->
          <section class="res__control">
            <!-- mediaType select start) -->
            <div class="res__mediaType">
              <small>Media type</small>
              <select class="content__type">
                <option value="application/json">application/json</option>
              </select>
              <small v-if="key === '200'" class="res__accept">
                Controls Accept header
              </small>
            </div>
            <!-- mediaType select end) -->

            <!-- examples select start) -->
            <div v-if="key === 'default'" class="res__examples">
              <small>Examples</small>
              <select class="examples__type" @change="getIndex($event)">
                <option v-for="value in examplesKey()">
                  {{ value }}
                </option>
              </select>
            </div>
            <!-- examples select end) -->
          </section>
          <!-- section end) -->

          <!-- black screen start) -->
          <div class="model__example">
            <!-- example || schema select start) -->
            <ul class="tab">
              <li class="tab__item">
                <a
                    v-if="key === '200'"
                    class="tab__links&quot;"
                    :class="[clickResult ? 'clicked' : '']"
                    @click="exampleValue(key)"
                >Example values</a
                >
                <span v-else style="font-weight: bold">Example values</span>
              </li>
              <li class="tab__item" v-if="key === '200'">
                <a
                    class="tab__links"
                    :class="[clickResult ? '' : 'clicked']"
                    @click="exampleSchema"
                >Schema</a
                >
              </li>
            </ul>
            <!-- example || schema select end) -->

            <!-- pre div start) -->
            <div class="model__box">
              <div v-if="key === '200' && clickResult">
                <pre>{{ successExamplePrint }}</pre>
              </div>
              <div v-else>
                  <pre v-if="key === '200'" class="schemaPre">
                    {{ successSchemaPrint }}
                  </pre>
                <div v-else>
                  <pre>{{ failSchemaPrint.value }}</pre>
                  <div class="pre__ex__des">
                    <p style="font-weight: bold">Example Description</p>
                    {{ failSchemaPrint.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <!-- td des end) -->
      </tr>
      <!-- tr end) -->
      </tbody>
      <!-- body end) body 부분 끝 -->
    </table>
  </div>
</template>

<script>
import responsesFile from '../data/document/openapi/responses.yaml';
import tokenErrorFile from '../data/document/responses/response.error.yaml';
import responsesErrorFile from '../data/document/openapi/response.error.yaml';
import {responseSchemaParser} from '../data/ApiData';
import MarkdownIt from 'markdown-it';

export default {
  name: 'ResponseComponent',
  props: {
    data: Object,
  },
  data() {
    return {
      clickResult: true,
      index: 0,
    };
  },
  methods: {
    exampleValue(key) {
      if (key === '200') this.clickResult = true;
      else this.clickResult = false;
    },
    exampleSchema() {
      this.clickResult = false;
    },
    examplesKey() {
      if (!Object.keys(this.data.responses).includes('default')) return;
      const schemaExamples =
          this.data.responses['default'].content['application/json'].examples;
      return Object.keys(schemaExamples);
    },
    getIndex(e) {
      this.index = e.target.selectedIndex;
    },
    converted(description) {
      const md = new MarkdownIt();
      let converted = md.render(description);
      converted = converted.replaceAll('&lt;br&gt;', '<br>');
      return converted;
    },
  },
  computed: {
    successSchema() {
      const schemaUrl =
          this.data.responses['200'].content['application/json'].schema['$ref'];
      const schemaVal = schemaUrl.split('#/')[1];

      return responseSchemaParser(responsesFile, schemaVal);
    },
    failSchema() {
      if (!Object.keys(this.data.responses).includes('default')) return;
      const schemaExamples =
          this.data.responses['default'].content['application/json'].examples;
      const examplesKeys = Object.keys(schemaExamples);
      const examplesUrl = [];
      for (let value of examplesKeys) {
        examplesUrl.push(schemaExamples[value]['$ref'].split('#/')[1]);
      }
      if (this.data.tags === 'Auth') {
        return responseSchemaParser(tokenErrorFile, examplesUrl);
      } else {
        return responseSchemaParser(responsesErrorFile, examplesUrl);
      }
    },
    successExamplePrint() {
      const hong = this.successSchema;

      // 권한 조회 때문에 만드는중..
      if (!hong.hasOwnProperty('properties')) {
        return hong.example;
      }

      const property = {};

      let exampleTypeArray = {};
      let exampleTypeObject = {};
      let exampleTypeOthers = {};

      for (let key of Object.keys(hong.properties)) {
        property[key] = hong.properties[key];
        if (property[key].type === 'array') {
          if (!property[key].items.hasOwnProperty('example')) {
            exampleTypeArray[key] = property[key].example;
          }
          exampleTypeArray[key] = property[key].items.example;
        } else if (property[key].type === 'object') {
          if (property[key].hasOwnProperty('example')) {
            exampleTypeOthers[key] = property[key].example;
          } else {
            for (let s of Object.keys(property[key].properties)) {
              exampleTypeObject[s] = property[key].properties[s].example;
              exampleTypeOthers[key] = exampleTypeObject;
            }
          }
        } else {
          exampleTypeOthers[key] = property[key].example;
        }
      }

      const example = {...exampleTypeOthers, ...exampleTypeArray};

      return example;
    },
    successSchemaPrint() {
      const hong = this.successSchema;

      // 권한 조회 때문에 만드는중..
      if (!hong.hasOwnProperty('properties')) {
        // 객체 속성 삭제하는데 불안해서 복사해서..
        const song = {...hong};
        delete song.example;
        return song;
      }

      const property = {};
      for (let key of Object.keys(hong.properties)) {
        property[key] = hong.properties[key];
      }

      return property;
    },
    failSchemaPrint() {
      if (!this.failSchema) return;
      const description = this.failSchema[this.index].description;
      const value = this.failSchema[this.index].value;

      if (!description) {
        return value;
      } else {
        return {description, value};
      }
    },
  },
};
</script>

<style scoped lang="scss">
table thead tr th {
  font-size: 12px;
  font-weight: 700;
  padding: 12px 0;
  text-align: left;
  border-bottom: 1px solid rgba(59, 65, 81, 0.2);
  font-family: sans-serif;
  color: #3b4151;
}

td {
  vertical-align: top;
  min-width: 15em;
  padding: 10px 0;
}

select {
  min-width: 230px;
  font-size: 14px;
  font-weight: 700;
  padding: 5px 40px 5px 10px;
  border: 2px solid #41444e;
  border-radius: 4px;
  background: #f7f7f7;
  background-size: 20px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 25%);
  font-family: sans-serif;
  color: #3b4151;
}

ul {
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 40px;
}

pre {
  padding: 10px;
  display: block;
  color: white;
  font-family: monospace;
  font-weight: 600;
  background: rgba(51, 51, 51, 100);
  border-radius: 3px;
  width: 99%;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  word-break: break-all;
  white-space: pre-wrap;
}

pre.schemaPre {
  background: #d0ddd8;
  color: black;
  width: 99%;
}

.col__header {
  border-bottom: 1px solid rgba(59, 65, 81, 0.2);
  font-weight: 700;
  font-size: 12px;
  color: #3b4151;
  font-family: sans-serif;
  padding: 12px 0;
}

.res__code {
  font-weight: 700;
  margin-right: 0.75em;
  font-family: sans-serif;
  color: #3b4151;
}

.res__description {
  width: 99%;
  margin-bottom: 2em;
}

.res__control {
  padding-top: 1em;
  display: flex;

  .res__mediaType {
    display: block;
    margin-bottom: 0.2em;
    font-size: 0.7em;

    .content__type {
      display: block;
      margin-right: 1em;
    }

    .res__accept {
      color: green;
      display: block;
      margin-bottom: 0.2em;
    }
  }

  .res__examples {
    display: block;
    margin-bottom: 0.2em;
    font-size: 0.7em;

    .examples__type {
      display: block;
    }
  }
}

.tab {
  display: flex;
  padding: 0;
  list-style: none;

  li:first-of-type {
    position: relative;
    padding-left: 0;
    padding-right: 12px;
  }

  li:first-of-type:after {
    position: absolute;
    top: 0;
    right: 6px;
    width: 1px;
    height: 100%;
    content: '';
    background: rgba(0, 0, 0, 0.2);
  }
}

li {
  font-size: 12px;
  min-width: 60px;
  cursor: pointer;
  font-family: sans-serif;
  color: #3b4151;
}

.clicked {
  font-weight: bold;
}

div::v-deep p > code {
  border-radius: 2px;
  background-color: rgba(51, 51, 51, 0.05);
  color: rgba(51, 51, 51, 0.9);
  padding: 0px 5px;
  border: 1px solid rgba(51, 51, 51, 0.1);
  font-family: Courier, monospace;
}
</style>
